import React, { Component } from 'react';
import { TermsAndConditionsList } from 'clorian-frontend-components';

class TermsAndConditionsContainer extends Component {

  render() {

    const {termsList, acceptTerm, selectedClientId} = this.props;
    return (
      <TermsAndConditionsList
        //disabled={disabled}
        termsList={termsList}
        handlerMethod={acceptTerm}
        clientId={selectedClientId}
      />
    );
  }

}




export default TermsAndConditionsContainer;